import store from 'reducers/store'
import { loadCarrierLogos } from 'reducers/modules/integrations'

store.dispatch(loadCarrierLogos())
